import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from "./index.module.css";

const SearchBarOnChange = ({ value, onSearch, onClear }) => {
    return (
        <div className={styles.searchBarContainer}>
            <div className={styles.searchIcon}>
                <FontAwesomeIcon icon={faSearch} />
            </div>
            <input
                type="text"
                className={styles.searchInput}
                placeholder="Search"
                value={value} // Controlled input
                onChange={(e) => onSearch(e.target.value)}
            />
        </div>
    );
};

export default SearchBarOnChange;